import createAPIRequestId from "../helpers/createAPIRequestId";
import store from "../store/index";
//--------------------------
// edit race characteristic
//--------------------------
export default async function useEditRaceCharacteristic(this_char) {
  console.log("-------------------------------------");
  console.log("IN useEditRaceCharacteristic....");
  return new Promise((resolve, reject) => {
    //--------------
    // access store
    //--------------
    const this_store = store;
    //--------------------
    // set api call parms
    //--------------------
    let parm_id = "";
    let parm_partialInd = false;

    if (this_char.id != "") {
      parm_id = this_char.id;
      parm_partialInd = true;
    }

    let request_parms = {
      endpoint: "api/v1/race-characteristics/",
      partialInd: parm_partialInd,
      id: parm_id,
    };
    //--------------------------
    // create api request by id
    //--------------------------
    let request = createAPIRequestId(request_parms);
    //---------------
    // set api parms
    //---------------
    let api_parms = {
      api_request: request,
      payload: this_char.payload,
    };
    //----------
    // call api
    //----------
    this_store
      .dispatch("races/editRaceCharacteristic", api_parms)
      .then((response) => {
        resolve(response);
      })
      .catch((err) => {
        reject(err);
      });
  });
}
